
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cholestq10",
      function () {
        return require("private-next-pages/cholestq10.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cholestq10"])
      });
    }
  